module.exports = __webpack_public_path__ + "static/media/sections.00acb86c.svg";